import React, { FC } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const TikTokIcon: FC<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            d="M20.402 10.283a4.805 4.805 0 0 1-4.463-2.15v7.398a5.469 5.469 0 1 1-5.47-5.468c.115 0 .226.01.338.017v2.695c-.112-.014-.222-.034-.338-.034a2.791 2.791 0 1 0 0 5.582c1.542 0 2.904-1.215 2.904-2.756L13.4 3h2.578a4.803 4.803 0 0 0 4.427 4.287v2.996"
            fill="#fff"
        />
    </svg>
);
